let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5cjJv")).then(() => parcelRequire('75ZZM'));